var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseLight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0126953 1.5066L1.51313 0L8.01523 6.52883L14.5373 0L16.0377 1.5066L9.51566 8.03543L16.0377 14.5843L14.5373 16.0909L8.01523 9.54203L1.51313 16.0909L0.0126953 14.5843L6.5148 8.03543L0.0126953 1.5066Z",
    fill: "#EFF6EC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseLight);
export default __webpack_public_path__ + "assets/media/close-light.cb047fd3a627e33271861fb9ca5ef43f.svg";
export { ForwardRef as ReactComponent };